import React from 'react';

import { LeadModel } from '@/typings/models/Lead';
import EditableTextField from '@/components/Lead/EditableTextField';
import classNames from 'classnames';
import styles from '@/components/Lead/index.less';


const getLeadEmail = (lead: LeadModel) => lead?.customer?.email

// Invalidated click to send email for the click to edit feature since it was overlapping. Added `href_invalid` prop to the EditableTextField component to properly invalidate clicking.
const LeadEmail = ({lead, readonly, noLink, isTable, isCustomer}: {
  isTable?: boolean,
  lead: LeadModel,
  readonly?: boolean,
  noLink?: boolean,
  isCustomer?: boolean
}) => {
  const leadEmail = getLeadEmail(lead)
  const representation = leadEmail || ' - '


  return (
    <EditableTextField
      isTable={isTable}
      editable={isCustomer ? false : !readonly}
      lead={lead}
      className={classNames(styles.leadEmail, {
        [styles.leadEmailTable]: isTable,
      })}
      property={'customer.email'}
    >
      {leadEmail && !noLink ? (
        <a href_invalid={`mailto:${representation}`}>{representation}</a>
      ) : (
        <span>{representation}</span>
      )}
    </EditableTextField>
  );
}

export default LeadEmail
